import { Icon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import { FaFileExport, FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  BLUEMONEDDBACKGROUND,
  BLUEMONEDDBUTTONS,
  REDMONEDD,
} from "../../../../constants/colors";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import {
  goToContaFixaList,
  goToListFavorites,
} from "../../../../routes/coordinator";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { componentState } from "../../../../atoms/componentState";
import { useEffect, useState } from "react";
import FavoritesAPi from "../../../../services/favoritesApi";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import SysTypesApi from "../../../../services/sysTypesApi";
import { PatternFormat } from "react-number-format";
import BankSelector from "../../../../defaultComponents/bankSelector";
import { LoggedUser } from "../../../../atoms/userLogged";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import ClientApi from "../../../../services/clientApi";

export default function AddAccounts() {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const cliente = Number(jwtToken.idCliente);
  // const cliente = useRecoilState(LoggedUser)[0].id;
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const setHeaderLocation = useSetRecoilState(componentState);
  // const [cliente, setCliente] = useState(0);
  const largura = window.screen.width;

  useEffect(() => {
    setHeaderLocation("Cadastro de Favorecidos");
  }, []);

  interface IFormInputs {
    idCliente: number;
    idTipoConta: number;
    nomeTitular: string;
    docTitular: string;
    nroBanco: string;
    nroAgencia: string;
    nroConta: string;
    nroContaDigito: string;
  }

  const schema = yup
    .object({
      nome: yup
        .string()
        .required("O nome da empresa deve ser preenchido")
        .min(5, "O nome da empresa deve conter mais de 5 caracteres")
        .max(100, "O nome da empresa não pode conter mais de 100 caracteres"),
    })
    .required();

  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>({ resolver: yupResolver(schema) });

  const initialValues = {
    idTipoConta: 1,
    nomeTitular: "",
    docTitular: "",
    nroAgencia: "",
    nroConta: "",
    nroContaDigito: "",
    nroBanco: "001",
    isRecAutomatico: false,
    isSplit: false,
    porcentagemSplit: null,
    idCliente: 0,
  };
  const [favored, setFavored] = useState<IFormInputs>(initialValues);

  async function addConta(obj: {}) {
    try {
      const response = await ClientApi.registerClientAccount(cliente, obj);
      toast.success("Conta cadastrada com successo!");
      setRefreshGlobal(refresh + 1);
      goToContaFixaList(navigate);
    } catch (error) {
      toast.error("Não foi possível cadastrar a conta!");
      console.log(error);
    }
  }

  async function onSubmit() {
    const temp = unMask(favored.docTitular);
    if (!cnpjValidator.isValid(temp) && !cpfValidator.isValid(temp)) {
      setError("docTitular", {
        type: "onBlur",
        message: "Este CPF/CNPJ não é válido!",
      });
    } else {
      setError("docTitular", { type: "onBlur", message: "" });
      if (!errors.nroAgencia?.message) {
        const objeto = [
          {
            // idCliente: cliente,
            idTipoConta: Number(favored.idTipoConta),
            nomeTitular: favored.nomeTitular,
            docTitular: unMask(favored.docTitular),
            nroBanco: favored.nroBanco,
            nroAgencia: favored.nroAgencia,
            nroAgenciaDigito: "D",
            nroConta: favored.nroConta,
            nroContaDigito: favored.nroContaDigito,
            isRecAutomatico: true,
            isSplit: false,
            porcentagemSplit: 0,
          },
        ];
        // console.log("objeto", objeto);
        addConta(objeto);
      } else {
        toast.error("Cadastre os 4 digitos na agência!");
      }
    }
  }

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function validateCNPJ(cnpj: any) {
    const temp = cnpj.match(/\d/g).join("");
    if (temp.length > 11) {
      if (!cnpjValidator.isValid(temp)) {
        setError("docTitular", {
          type: "onBlur",
          message: "Este CNPJ não é válido!",
        });
      } else {
        setError("docTitular", { type: "onBlur", message: "" });
      }
    } else {
      if (!cpfValidator.isValid(temp)) {
        setError("docTitular", {
          type: "onBlur",
          message: "Este CPF não é válido!",
        });
      } else {
        setError("docTitular", { type: "onBlur", message: "" });
      }
    }
  }

  const [types, setTypes] = useState([
    {
      id: 0,
      nome: "",
    },
  ]);

  const getTypeAccount = async () => {
    try {
      const response = await SysTypesApi.sysTypeAccount(1, 100, "");
      setTypes(response);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTypeAccount();
  }, []);

  return (
    <>
      <Flex
        w={"100%"}
        h={"100%"}
        alignItems="center"
        justifyContent="center"
        bg={"#F1F1F1"}
      >
        <Flex
          w={"95%"}
          h={"95%"}
          bgColor={BLUEMONEDDBACKGROUND}
          borderRadius={"20px"}
          justifyContent="center"
          alignItems={"center"}
        >
          <Flex
            w={"90%"}
            height="90%"
            flexDirection={"column"}
            justifyContent="space-evenly"
          >
            <Text fontWeight={"bold"} fontSize={"2vw"} color={"white"}>
              CADASTRO DE CONTA FIXA
            </Text>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl>
                <FormLabel color="white" fontSize={"1vw"}>
                  Coloque o nome do titular da Conta.
                </FormLabel>
                <Input
                  mb={2}
                  type="text"
                  bg="white"
                  h={"2.5vw"}
                    fontSize={"1vw"}
                  placeholder="Digite o nome do titular"
                  onChange={(e: any) => {
                    setFavored({ ...favored, nomeTitular: e.target.value });
                  }}
                />
                <Text color="red" mt="-3" mb={2}>
                  {errors.nomeTitular?.message}
                </Text>
              </FormControl>
              <Flex w="100%" justifyContent={"space-between"} alignItems={"center"}>
                <FormControl w="45%">
                  <FormLabel color="white" fontSize={"1vw"}>CPF ou CNPJ</FormLabel>
                  <PatternFormat
                    bg="white"
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    customInput={Input}
                    format={
                      unMask(favored.docTitular).length > 11
                        ? "##.###.###/####-##"
                        : "###.###.###-###"
                    }
                    type="text"
                    placeholder="Digite o CPF ou CNPJ"
                    value={favored.docTitular}
                    // {...register("cnpjDestinatario", { required: true })}
                    onChange={(e: any) => {
                      setFavored({ ...favored, docTitular: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      e.target.value && validateCNPJ(e.target.value);
                    }}
                  />
                  <Text color="red" mb={2}>
                    {errors.docTitular?.message}
                  </Text>
                </FormControl>
                <FormControl w="45%">
                  <FormLabel color="white" fontSize={"1vw"}>Banco</FormLabel>
                  
                  <BankSelector banco={favored} setBanco={setFavored} />
                  <Text color="red" mb={2}>
                    
                  </Text>
                </FormControl>
              </Flex>
              <Flex w="100%" justifyContent={"space-between"} alignItems={"center"}>
                <FormControl w="30%">
                  <FormLabel color="white" fontSize={"1vw"} display={"flex"}>
                    <Text>
                      Digite a Agência{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        (sem Dígito)
                      </span>
                    </Text>
                  </FormLabel>
                  <Input
                    w={"12vw"}
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    maxLength={4}
                    placeholder="NNNN"
                    minLength={4}
                    bg="white"
                    value={favored.nroAgencia}
                    onChange={(event: any) =>
                      setFavored({ ...favored, nroAgencia: event.target.value })
                    }
                    onBlur={(e: any) => {
                      e.target.value && e.target.value.length < 4
                        ? setError("nroAgencia", {
                            type: "onBlur",
                            message: "Agência deve conter 4 digitos",
                          })
                        : setError("nroAgencia", {
                            type: "onBlur",
                            message: "",
                          });
                    }}
                  />
                  {/* <PatternFormat
                    bg="white"
                    format={"####"}
                    placeholder="NNNN"
                    mask={["N", "N", "N", "N"]}
                    customInput={Input}
                    w={"12vw"}
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    value={favored.nroAgencia}
                    onChange={(event: any) =>
                      setFavored({ ...favored, nroAgencia: event.target.value })
                    }
                  /> */}
                  <Text color="red" mb={2}>
                    {errors.nroAgencia?.message}
                  </Text>
                </FormControl>
                {/* <FormControl w={"30%"}>
                  <FormLabel color="white" fontSize={"1vw"} display={"flex"}><Text>Digite a Agência <span style={{fontWeight: "bold", color:"red"}}>(sem Dígito)</span></Text></FormLabel>
                  <PatternFormat
                    bg="white"
                    format={"####"}
                    placeholder="NNNN"
                    mask={["N", "N", "N", "N"]}
                    customInput={Input}
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    w={"12vw"}
                    value={favored.nroAgencia}
                    onChange={(event: any) =>
                      setFavored({ ...favored, nroAgencia: event.target.value })
                    }
                  />
                  <Text color="red" mb={2}>
                    {errors.nroAgencia?.message}
                  </Text>
                </FormControl> */}
                <Flex
                  width={"45vw"}
                  justifyContent={"space-evenly"}
                  alignItems={"center"}
                  // bg={"yellow"}
                >
                  <FormControl>
                    <FormLabel color="white" fontSize={"1vw"} display={"flex"} >
                      <Text>Digite o Número da Conta <span style={{fontWeight: "bold", color:"red"}}>(sem Dígito)</span></Text>
                    </FormLabel>
                      <Input
                        bg="white"
                        type="text"
                        maxLength={10}
                        h={"2.5vw"}
                        fontSize={"1vw"}
                        w={"18vw"}
                        mx={1}
                        placeholder="Digite o número da conta"
                        value={favored.nroConta}
                        {...register("nroConta", { required: true })}
                        onChange={(e: any) => {
                          setFavored({
                            ...favored,
                            nroConta: e.target.value,
                          });
                        }}
                      />
                    <Text color="red" mb={2}>
                      {errors.nroConta?.message}
                    </Text>
                  </FormControl>
                  <Text color={"white"} mt={5} mr={1}>-</Text>
                  <FormControl>
                    <FormLabel color="white" fontSize={"1vw"}>
                      <Text>Digite <span style={{fontWeight: "bold", color:"red"}}>somente o Dígito</span> da conta</Text>
                    </FormLabel>
                    <Input
                      bg="white"
                      type="text"
                      maxLength={1}
                      mx={1}
                      h={"2.5vw"}
                      fontSize={"1vw"}
                      w={"50px"}
                      //   placeholder="Dígito"
                      value={favored.nroContaDigito}
                      {...register("nroContaDigito", { required: true })}
                      onChange={(e: any) => {
                        setFavored({
                          ...favored,
                          nroContaDigito: e.target.value,
                        });
                      }}
                    />
                    <Text color="red" mb={2}>
                      
                    </Text>
                  </FormControl>
                </Flex>
                <FormControl w="15%">
                  <FormLabel color="white" fontSize={"1vw"}>Tipo de Conta</FormLabel>
                  <Select
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    bg="white"
                    onChange={(event: any) =>
                      setFavored({
                        ...favored,
                        idTipoConta: event.target.value,
                      })
                    }
                  >
                    {types &&
                      types.map((item: any) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.nome}
                          </option>
                        );
                      })}
                  </Select>
                </FormControl>
              </Flex>

              <Flex justifyContent={"space-between"} w={largura < 900 ? "30vw" : "20vw"}>
                <Button
                  type="submit"
                  bgColor={BLUEMONEDDBUTTONS}
                  color="white"
                  h={"2.5vw"}
                  fontSize={"1vw"}
                  isDisabled={
                    cliente != 0 &&
                    favored.docTitular != "" &&
                    favored.nomeTitular != "" &&
                    favored.nroAgencia != "" &&
                    favored.nroConta != "" &&
                    favored.nroContaDigito != "" &&
                    Number(favored.idTipoConta) != 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    onSubmit();
                  }}
                >
                  <Icon mr={2} as={FaSave} />
                  SALVAR
                </Button>
                <Button
                  bgColor={REDMONEDD}
                  h={"2.5vw"}
                  fontSize={"1vw"}
                  color="white"
                  onClick={() => goToContaFixaList(navigate)}
                >
                  X CANCELAR
                </Button>
              </Flex>
            </form>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}
